import { render, staticRenderFns } from "./distributionStatic.vue?vue&type=template&id=4c4b3e9b&scoped=true&"
import script from "./distributionStatic.vue?vue&type=script&lang=js&"
export * from "./distributionStatic.vue?vue&type=script&lang=js&"
import style0 from "./distributionStatic.vue?vue&type=style&index=0&id=4c4b3e9b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c4b3e9b",
  null
  
)

export default component.exports